'use strict';
define([], function () {
    function Controller(__env, $scope, $rootScope, $state, $stateParams, canDoTrial, TrackEventService, $mdMedia, LanguageService, PlanDetailsService, $window, UtilitiesService, $location, CRMService, AuthService, UserService, SuiteTheme, $translate) {
        var vm = $scope;
        var platformCardObserver = null;
        var platformRevealTimer = null;
        vm.$mdMedia = $mdMedia;
        vm.filterPlansByActiveType = filterPlansByActiveType;
        vm.switchBillingType = switchBillingType;

        vm.planTypes = [
            {
                label: 'Personal',
                value: 'Personal'
            },
            {
                label: 'Agency',
                value: 'Agency'
            },
            {
                label: 'Enterprise',
                value: 'Enterprise'
            }
        ];
        vm.selectPlanOptions = ['Personal', 'Agency', 'Enterprise'];
        vm.enterpriseFeatures = [
            'access.talk.with.dedicated.account.managers',
            'access.extend.as.you.need.your.companys.limits',
            'access.collaborate.with.us.and.build.your.custom.tools',
            'access.custom.apis',
            'access.webhooks',
            'access.enterprise.tailor.made.solutions',
            'access.get.help.from.seo.advisors.and.trainers.from.our.network',
            'access.access.to.our.premium.customer.support'
        ];
        vm.platformTools = [
            {
                id: 'audit',
                number: '01',
                icon: 'ti-world-search',
                featured: true,
                labelKey: 'pricing.platform.audit.label',
                titleKey: 'pricing.platform.audit.title',
                bulletKeys: [
                    'pricing.platform.audit.item.one',
                    'pricing.platform.audit.item.two'
                ]
            },
            {
                id: 'tracking',
                number: '02',
                icon: 'ti-chart-line',
                labelKey: 'pricing.platform.tracking.label',
                titleKey: 'pricing.platform.tracking.title',
                bulletKeys: [
                    'pricing.platform.tracking.item.one',
                    'pricing.platform.tracking.item.two'
                ]
            },
            {
                id: 'content',
                number: '03',
                icon: 'ti-file-text-ai',
                labelKey: 'pricing.platform.content.label',
                titleKey: 'pricing.platform.content.title',
                bulletKeys: [
                    'pricing.platform.content.item.one',
                    'pricing.platform.content.item.two'
                ]
            },
            {
                id: 'research',
                number: '04',
                icon: 'ti-search',
                wide: true,
                labelKey: 'pricing.platform.research.label',
                titleKey: 'pricing.platform.research.title',
                bulletKeys: [
                    'pricing.platform.research.item.one',
                    'pricing.platform.research.item.two'
                ]
            },
            {
                id: 'competitors',
                number: '05',
                icon: 'ti-radar',
                labelKey: 'pricing.platform.competitors.label',
                titleKey: 'pricing.platform.competitors.title',
                bulletKeys: [
                    'pricing.platform.competitors.item.one',
                    'pricing.platform.competitors.item.two'
                ]
            },
            {
                id: 'reports',
                number: '06',
                icon: 'ti-report-analytics',
                labelKey: 'pricing.platform.reports.label',
                titleKey: 'pricing.platform.reports.title',
                bulletKeys: [
                    'pricing.platform.reports.item.one',
                    'pricing.platform.reports.item.two'
                ]
            },
            {
                id: 'leads',
                number: '07',
                icon: 'ti-user-plus',
                labelKey: 'pricing.platform.leads.label',
                titleKey: 'pricing.platform.leads.title',
                bulletKeys: [
                    'pricing.platform.leads.item.one',
                    'pricing.platform.leads.item.two'
                ]
            }
        ];
        vm.platformRevealReady = false;

        vm.isPromoTime = PlanDetailsService.isPromoTime() && PlanDetailsService.getCurrentPromo().promoType === 'all-platform-promo';
        vm.promoName = PlanDetailsService.isPromoTime() ? PlanDetailsService.getCurrentPromo().id : '';
        vm.headerSticky = true;
        vm.showStickyPromoCountdown = false;
        vm.showStickyPromoBanner = false;

        if (vm.isPromoTime) {
            applyPromoChanges();
            vm.currentPromo = PlanDetailsService.getCurrentPromo();
            vm.currentPromoModifierClass = PlanDetailsService.getCurrentPromo().currentPromoModifierClass;
        }

        if ($stateParams.type && vm.selectPlanOptions.indexOf(capitalize($stateParams.type)) >= 0) {
            vm.activePlansType = capitalize($stateParams.type);
        } else {
            vm.activePlansType = 'Agency';
        }

        if ($stateParams.periods && ($stateParams.periods.toLowerCase() === 'annually' || $stateParams.periods.toLowerCase() === 'monthly')) {
            vm.billingType = $stateParams.periods.toLowerCase();
            //vm.switchBillingType($stateParams.periods.toLowerCase());
        } else {
            vm.billingType = 'annually';
        }

        TrackEventService.event('Funnel Events', 'Entered Pricing', 'Suite');
        TrackEventService.gaV2Event('screen_view', {
            screen_name: 'pricing-suite',
        });

        if ($stateParams.dealId) {
            checkOnLocalStorage('dealId', $stateParams.dealId);
        }

        if ($stateParams.saleOwner) {
            checkOnLocalStorage('saleOwner', $stateParams.saleOwner);
        }

        vm.faqs = UtilitiesService.getFaqs();
        vm.faqColumns = [
            vm.faqs.slice(0, Math.ceil(vm.faqs.length / 2)),
            vm.faqs.slice(Math.ceil(vm.faqs.length / 2))
        ];
        vm.pricingTitle = 'pricing';

        vm.selectedLang = LanguageService.getCodeAndCountrySaveOnStorage();
        vm.themePreference = SuiteTheme.getPreference();
        vm.setThemePreference = function (preference) {
            SuiteTheme.setPreference(preference);
            vm.themePreference = SuiteTheme.getPreference();
        };
        vm.cycleThemePreference = function () {
            var preferences = ['light', 'dark', 'system'];
            var currentIndex = preferences.indexOf(vm.themePreference);
            vm.setThemePreference(preferences[(currentIndex + 1) % preferences.length]);
        };
        vm.formatNumber = formatNumber;
        vm.formatPrice = formatPrice;
        vm.formatPlanPrice = formatPlanPrice;
        vm.formatMetric = formatMetric;
        vm.planBaseMonthlyAmount = planBaseMonthlyAmount;
        vm.planAnnualTotal = planAnnualTotal;
        vm.promoAppliesToBilling = promoAppliesToBilling;
        vm.promoStats = promoStats;
        updatePlanCatalog();
        initializeStickyHeader();
        initializePlatformReveal();

        $scope.$on('$destroy', function () {
            if (platformRevealTimer) {
                $window.clearTimeout(platformRevealTimer);
                platformRevealTimer = null;
            }
            if (platformCardObserver) {
                platformCardObserver.disconnect();
                platformCardObserver = null;
            }
        });

        $scope.$on('suiteThemeChanged', function (event, mode, preference) {
            vm.themePreference = preference || SuiteTheme.getPreference();
        });

        vm.canDoTrial = function () {
            return canDoTrial !== false;
        };

        vm.goToCheckout = function (plan) {
            var planAlias = plan.annualAlias;
            if (vm.billingType === 'monthly') {
                planAlias = plan.monthlyAlias;
            }

            var checkoutParams = {alias: planAlias};
            var coupon = $window.localStorage.getItem('coupon');
            if (coupon) {
                checkoutParams.coupon = coupon;
            }
            $state.go('upgrade.checkout', checkoutParams);
        };

        vm.goToExternalContactPage = function () {
            var language = LanguageService.getCodeAndCountrySaveOnStorage();

            switch (language) {
                case 'it-IT':
                    $window.open("https://it.seotesteronline.com/contatti/", '_blank');
                    break;
                case 'es-ES':
                    $window.open("https://es.seotesteronline.com/contacts/", '_blank');
                    break;
                case 'pl-PL':
                    $window.open("https://pl.seotesteronline.com/contacts/", '_blank');
                    break;
                default:
                    $window.open("https://www.seotesteronline.com/contacts/", '_blank');
            }
        };

        vm.goToExternalApplyNowPage = function () {
            var language = LanguageService.getCodeAndCountrySaveOnStorage();

            switch (language) {
                case 'it-IT':
                    $window.open("https://seotesteronline.typeform.com/to/y6vbtYWd", '_blank');
                    break;
                case 'es-ES':
                    $window.open("https://seotesteronline.typeform.com/to/x5Dvl62o", '_blank');
                    break;
                default:
                    $window.open("https://seotesteronline.typeform.com/to/x5Dvl62o", '_blank');
            }
        };

        vm.switchLang = function (language) {
            vm.selectedLang = language;
            $rootScope.setLang(language);

            if (!AuthService.isAuthenticated()) {
                return;
            }

            UserService.updateProfile({locale: language})
                .catch(function (err) {
                    console.log(err);
                });
        };

        function switchBillingType(billingType) {
            vm.billingType = billingType;
            vm.filterPlansByActiveType();
        }

        function filterPlansByActiveType() {
            vm.pricingTitle = 'pricing';
            updatePlanCatalog();
        }

        function initializeStickyHeader() {
            var animationFrame = null;
            var headerElement;
            var compareElement;
            var heroCountdownElement;

            function getVisibleCompareElement() {
                var compareElements = $window.document.querySelectorAll('#sto-pricing-compare');
                var visibleElement = null;

                Array.prototype.some.call(compareElements, function (element) {
                    if (element.offsetParent !== null) {
                        visibleElement = element;
                        return true;
                    }
                    return false;
                });

                return visibleElement || compareElements[0] || null;
            }

            function updateStickyState() {
                animationFrame = null;
                headerElement = headerElement || $window.document.querySelector('.pricing-site-header');
                compareElement = compareElement || getVisibleCompareElement();
                heroCountdownElement = heroCountdownElement
                    || $window.document.querySelector('.pricing-promo-hero__countdown');

                if (!headerElement) {
                    return;
                }

                var headerHeight = headerElement.getBoundingClientRect().height || 62;
                var compareTop = compareElement
                    ? compareElement.getBoundingClientRect().top
                    : Number.POSITIVE_INFINITY;
                var compareBottom = compareElement
                    ? compareElement.getBoundingClientRect().bottom
                    : Number.POSITIVE_INFINITY;
                var nextHeaderSticky = compareTop > headerHeight;
                var nextShowCountdown = vm.isPromoTime
                    && nextHeaderSticky
                    && !!heroCountdownElement
                    && heroCountdownElement.getBoundingClientRect().bottom <= headerHeight;
                var nextShowPromoBanner = vm.isPromoTime && compareBottom <= headerHeight;

                if (vm.headerSticky === nextHeaderSticky
                    && vm.showStickyPromoCountdown === nextShowCountdown
                    && vm.showStickyPromoBanner === nextShowPromoBanner) {
                    return;
                }

                vm.headerSticky = nextHeaderSticky;
                vm.showStickyPromoCountdown = nextShowCountdown;
                vm.showStickyPromoBanner = nextShowPromoBanner;
                $scope.$evalAsync();
            }

            function scheduleStickyUpdate() {
                if (animationFrame) {
                    return;
                }

                animationFrame = $window.requestAnimationFrame
                    ? $window.requestAnimationFrame(updateStickyState)
                    : $window.setTimeout(updateStickyState, 16);
            }

            $window.addEventListener('scroll', scheduleStickyUpdate, {passive: true});
            $window.addEventListener('resize', scheduleStickyUpdate);
            $scope.$on('$viewContentLoaded', scheduleStickyUpdate);
            $scope.$on('$destroy', function () {
                $window.removeEventListener('scroll', scheduleStickyUpdate);
                $window.removeEventListener('resize', scheduleStickyUpdate);

                if (animationFrame && $window.cancelAnimationFrame) {
                    $window.cancelAnimationFrame(animationFrame);
                }
            });

            scheduleStickyUpdate();
        }

        function initializePlatformReveal() {
            platformRevealTimer = null;
            var section = $window.document.querySelector('.pricing-platform');
            if (!section) {
                platformRevealTimer = $window.setTimeout(initializePlatformReveal, 120);
                return;
            }
            if (platformCardObserver) {
                return;
            }

            var cards = section.querySelectorAll('.pricing-platform-card');
            if (!cards.length) {
                platformRevealTimer = $window.setTimeout(initializePlatformReveal, 120);
                return;
            }

            if (typeof $window.IntersectionObserver !== 'function') {
                vm.platformTools.forEach(function (tool) {
                    tool.visible = true;
                });
                return;
            }

            $scope.$evalAsync(function () {
                vm.platformRevealReady = true;
            });
            platformCardObserver = new $window.IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    var index = Number(entry.target.getAttribute('data-platform-index'));
                    if (Number.isInteger(index) && vm.platformTools[index]) {
                        $scope.$evalAsync(function () {
                            vm.platformTools[index].visible = true;
                        });
                    }
                    platformCardObserver.unobserve(entry.target);
                });
            }, {
                rootMargin: '0px 0px -8% 0px',
                threshold: 0.18
            });

            Array.prototype.forEach.call(cards, function (card) {
                platformCardObserver.observe(card);
            });

        }

        function updatePlanCatalog() {
            vm.personalPlans = applyPromoBillingEligibility(
                getPublicPlans(PlanDetailsService.getPlansByType('Personal')),
            );
            vm.agencyPlans = applyPromoBillingEligibility(
                getPublicPlans(PlanDetailsService.getPlansByType('Agency')),
            );
            vm.plans = applyPromoBillingEligibility(
                getPublicPlans(PlanDetailsService.getPlansByType(vm.activePlansType)),
            );
            vm.allPlans = vm.personalPlans.concat(vm.agencyPlans);
            vm.maxAnnualDiscount = vm.allPlans.reduce(function (maximum, plan) {
                if (!plan.monthlyAmount || !Number.isFinite(Number(plan.annualAmount))) {
                    return maximum;
                }
                var discount = Math.round((1 - Number(plan.annualAmount) / Number(plan.monthlyAmount)) * 100);
                return Math.max(maximum, discount);
            }, 0);
            vm.planGroups = [
                {
                    key: 'available',
                    plans: vm.allPlans
                }
            ];
        }

        function getPublicPlans(plans) {
            var publicPlanNames = ['Plus', 'Advanced', 'Premium', 'Infinity'];
            return plans.filter(function (plan) {
                return publicPlanNames.indexOf(plan.name) !== -1;
            }).map(function (plan) {
                var features = plan.features[0];
                plan.cardLimits = [
                    {label: 'users', value: features.platform.users},
                    {label: 'projects', value: features.platform.projects},
                    {label: 'trackedKeyword', value: features.positionMonitoring.trackedKeyword},
                    {label: 'resultsPerKeyword', value: features.keywordResearch.resultsPerKeyword},
                    {label: 'websitesMonitorable', value: features.platform.projects},
                    {label: 'websitesScannable', value: features.platform.projects}
                ];
                plan.cardHighlights = [
                    {label: 'aiCredits', value: features.ai.aiCredits},
                    {label: 'dataRetention', value: features.onSiteSeoAudit.dataRetention}
                ];
                return plan;
            });
        }

        vm.gotoElement = function (eID) {
            // set the location.hash to the id of
            // the element you wish to scroll to.
            $location.hash(eID);

            // call $anchorScroll()
            UtilitiesService.scrollTo(eID, 'pricing-container');
        };

        /**
         * Retrieve if exist the value of Deal Id
         * otherwise we set on local Storage new Deal ID
         * @param {string} key
         * @param {string} value
         */
        function checkOnLocalStorage(key, value) {
            // If key exist on url we check if it same on localstorage
            // if not same update it
            var valueSaved = $window.localStorage.getItem(key);

            if (valueSaved) {
                $window.localStorage.removeItem(key);
                $window.localStorage.setItem(key, value);
            } else {
                // If not exist we add new value on local storage
                $window.localStorage.setItem(key, value);
            }
        }

        function applyPromoChanges() {
            // on black friday promotion there are no enterprise plans
            vm.planTypes = [
                {
                    label: 'Personal',
                    value: 'Personal'
                },
                {
                    label: 'Agency',
                    value: 'Agency'
                }
            ];

            vm.selectPlanOptions = ['Personal', 'Agency'];
        }

        function animateValue(elID, start, end, duration) {
            var obj = document.getElementById(elID);

            if (!obj) {
                return;
            }
            var startTimestamp = null;
            var step = function (timestamp) {
                if (!startTimestamp) {
                    startTimestamp = timestamp;
                }
                var progress = Math.min((timestamp - startTimestamp) / duration, 1);
                obj.innerHTML = Math.floor(progress * (end - start) + start);
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }

        function animatePrices() {
            var animationDuration = 700;

            if (!vm.isPromoTime) {
                animateValue('price-1', vm.billingType != 'annually' ? vm.plans[0].annualAmount : vm.plans[0].monthlyAmount, vm.billingType != 'annually' ? vm.plans[0].monthlyAmount : vm.plans[0].annualAmount, animationDuration);
                animateValue('price-2', vm.billingType != 'annually' ? vm.plans[1].annualAmount : vm.plans[1].monthlyAmount, vm.billingType != 'annually' ? vm.plans[1].monthlyAmount : vm.plans[1].annualAmount, animationDuration);
                animateValue('price-3', vm.billingType != 'annually' ? vm.plans[2].annualAmount : vm.plans[2].monthlyAmount, vm.billingType != 'annually' ? vm.plans[2].monthlyAmount : vm.plans[2].annualAmount, animationDuration);
            } else {
                animateValue('promo-price-1', vm.billingType != 'annually' ? vm.plans[0].annualAmount : vm.plans[0].monthlyAmount, vm.billingType != 'annually' ? vm.plans[0].monthlyAmount : vm.plans[0].annualAmount, animationDuration);
                animateValue('promo-price-2', vm.billingType != 'annually' ? vm.plans[1].annualAmount : vm.plans[1].monthlyAmount, vm.billingType != 'annually' ? vm.plans[1].monthlyAmount : vm.plans[1].annualAmount, animationDuration);
                animateValue('promo-price-3', vm.billingType != 'annually' ? vm.plans[2].annualAmount : vm.plans[2].monthlyAmount, vm.billingType != 'annually' ? vm.plans[2].monthlyAmount : vm.plans[2].annualAmount, animationDuration);
            }
        }

        function capitalize(string) {
            return string[0].toUpperCase() + string.substring(1);
        }

        function formatNumber(value) {
            var numericValue = Number(value);
            if (value === null || typeof value === 'undefined' || value === '' || !Number.isFinite(numericValue)) {
                return value;
            }
            var locale = LanguageService.getCodeAndCountrySaveOnStorage() || 'en-US';
            try {
                return new Intl.NumberFormat(locale, {useGrouping: 'always'}).format(numericValue);
            } catch (error) {
                return new Intl.NumberFormat(locale).format(numericValue);
            }
        }

        function formatPlanPrice(plan, billingType) {
            if (billingType !== 'annually') {
                if (vm.isPromoTime && plan.monthlyAmountDecimal) {
                    return formatPrice(
                        Number(plan.monthlyAmount)
                        + (Number(plan.monthlyAmountDecimal) / 100),
                    );
                }
                return formatNumber(plan.monthlyAmount);
            }

            if (!vm.isPromoTime) {
                return formatNumber(plan.annualAmount);
            }

            return formatPrice(planAnnualTotal(plan) / 12);
        }

        function formatPrice(value) {
            var locale = LanguageService.getCodeAndCountrySaveOnStorage() || 'en-US';
            try {
                return new Intl.NumberFormat(locale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(Number(value));
            } catch (error) {
                return Number(value).toFixed(2).replace('.', ',');
            }
        }

        function planAnnualTotal(plan) {
            var amount = Number(plan.annualAmount)
                + (Number(plan.annualAmountDecimal || 0) / 100);
            return amount * 12;
        }

        function planBaseMonthlyAmount(plan) {
            return Number(plan.monthlyAmountBeforePromo || plan.monthlyAmount);
        }

        function promoAppliesToBilling() {
            return !vm.isPromoTime
                || !vm.currentPromo
                || !vm.currentPromo.annualOnly
                || vm.billingType === 'annually';
        }

        function applyPromoBillingEligibility(plans) {
            if (promoAppliesToBilling()) {
                return plans;
            }

            return plans.map(function (plan) {
                plan.monthlyAmount = Number(plan.monthlyAmountBeforePromo || plan.monthlyAmount);
                plan.monthlyAmountDecimal = null;
                plan.monthlyAmountSavedForYear = 0;
                return plan;
            });
        }

        function promoStats() {
            var plans = (vm.planGroups || []).reduce(function (allPlans, group) {
                return allPlans.concat(group.plans || []);
            }, []);
            if (!plans.length) {
                plans = vm.plans || [];
            }
            var isAnnual = vm.billingType === 'annually';
            var startingPrice = null;
            var maxSaving = 0;

            plans.forEach(function (plan) {
                var currentPrice;
                var saving;

                if (isAnnual) {
                    currentPrice = planAnnualTotal(plan) / 12;
                    saving = (planBaseMonthlyAmount(plan) * 12) - planAnnualTotal(plan);
                } else {
                    currentPrice = Number(plan.monthlyAmount)
                        + (Number(plan.monthlyAmountDecimal || 0) / 100);
                    saving = Number(plan.monthlyAmountBeforePromo || plan.monthlyAmount)
                        - currentPrice;
                }

                if (Number.isFinite(currentPrice)) {
                    startingPrice = startingPrice === null
                        ? currentPrice
                        : Math.min(startingPrice, currentPrice);
                }
                if (Number.isFinite(saving)) {
                    maxSaving = Math.max(maxSaving, saving);
                }
            });

            return {
                planCount: plans.length,
                startingPrice: startingPrice === null ? null : formatPrice(startingPrice),
                maxSaving: formatPrice(maxSaving),
                savingInterval: isAnnual ? 'anno' : 'mese',
            };
        }

        function formatMetric(value) {
            var text = String(value);
            if (typeof value === 'number' || /^-?\d+$/.test(text.trim())) {
                return formatNumber(value);
            }
            var translated = $translate.instant(text);
            if (translated !== text) {
                return translated;
            }
            return text;
        }

        if (AuthService.isAuthenticated() && vm.canDoTrial()) {
            CRMService.addEvents(['UserToTrialPricingRecoverEvent']);
        }
    }

    Controller.$inject = ['__env', '$scope', '$rootScope', '$state', '$stateParams', 'canDoTrial', 'TrackEventService', '$mdMedia', 'LanguageService', 'PlanDetailsService', '$window', 'UtilitiesService', '$location', 'CRMService', 'AuthService', 'UserService', 'SuiteTheme', '$translate'];
    return Controller;
});
